import React, { useEffect, useMemo, useRef, useState } from 'react'
import styled from 'styled-components/macro'
import defaultToy from './../../assets/defaultToy.png'
import defaultAvatar from './../../assets/cardPhoto.png'
import axios from '../../utils/axios'
import { useNavigationType, useParams } from 'react-router-dom'
import { selectIsAuth } from '../../redux/slices/auth'
import CardPreview from '../Card/card-preview';
import { useDispatch, useSelector } from 'react-redux'
import LoaderCircle from './../../ui-kit/loader-circle/loader-circle'
import { DOTS, getPagination } from '../MainPage/get-pagination'
import { cardsSelect, fetchMyCards, saveScrollPosition, setCurrentPage, setPageSize } from '../../redux/slices/cards'

const Card = styled.section`
max-width: 1200px;
display: grid;
grid-template-columns: 1fr 1fr 1fr 1fr;
grid-gap: 40px;
justify-content: center;
margin: 0 auto 30px;
 
@media (max-width: 577px){
  grid-template-columns: 50% 50%; 
  grid-gap: 10px;
  padding: 0;
  margin: 0;
    padding-top: 26px;
    grid-template-columns: repeat(2,1fr);
    grid-gap: 15px;
    grid-template-rows: 269px;
    grid-auto-rows: 269px;
  & > a {
      overflow: hidden;
    }
}
`

const PaginationBtn = styled.button`
  width: 30px;
  height: 30px;
  color: #808183;
  border-bottom: 1px solid rgba(171, 154, 144, 0.3);  
  border-top: 1px solid rgba(171, 154, 144, 0.3);  
  border-right: 1px solid rgba(171, 154, 144, 0.3);  
  border-left: none;  
  cursor: pointer;
  background: transparent;
  opacity: 0.9;
  font-family: "Montserrat",sans-serif;
  display: block;
`

const PaginationBtnFirst = styled.button`
  display: block;
  width: 30px;
  height: 30px;
  color: #808183;
  border: 1px solid rgba(145,114,114,0.2);
  cursor: pointer;
  background: transparent;
  border-radius: 10px 0 0 10px;
  opacity: 0.9;
`

const PaginationBtnActive = styled.button`
  display: block;
  width: 30px;
  height: 30px;
  color: #FFFFFF;
  border: 1px solid rgba(145,114,114,0.2);  
  cursor: pointer;
  background: #FE6103;
  opacity: 0.35;
  font-family: "Montserrat",sans-serif;
`

const PaginationBtnLast = styled.button`
  display: block;
  width: 30px;
  height: 30px;
  color: #808183;
  border-right: 1px solid rgba(145,114,114,0.2); 
  border-top: 1px solid rgba(145,114,114,0.2);
  border-bottom: 1px solid rgba(145,114,114,0.2);
  border-left: none;   
  cursor: pointer;
  background: transparent;
  border-radius: 0 10px 10px 0;
  opacity: 0.9;
`

const PaginationWrapper = styled.div`
  margin: 20px auto 30px;
  display: flex;
  align-items: center;
  max-width: 1200px;
`

const PAGE_SIZE = 12;

const CardBlock = ({ id }) => {
    const isAuth = useSelector(selectIsAuth)
    const params = useParams()
    const dispatch = useDispatch();
    const userId = id || params.id;
    const cardsState = useSelector(cardsSelect)
    const sectionRef = useRef(null);
    const [isInitialFetched, setIsInitialFetched] = useState(false);
    const navType = useNavigationType();

    const [loading, setLoading] = useState(false);

    const pagination = useMemo(() => getPagination({
      totalPageCount: cardsState.pages,
      currentPage: cardsState.currentPage
    }), [cardsState.currentPage, cardsState.pages]);

    const changePage = async(nextPage, nextCathegory) => {
      setLoading(true);
      dispatch(setCurrentPage(nextPage));
      await dispatch(fetchMyCards({userId}));
      setLoading(false);
  
      sectionRef.current && window.scrollTo({ top: sectionRef.current.offsetTop })
    }

    useEffect(() => {
      dispatch(setPageSize(PAGE_SIZE));
      if (!cardsState.items.length) {
        setLoading(true);
      }
      dispatch(fetchMyCards({userId}))
        .then(() => {
          setIsInitialFetched(true);
          setLoading(false);
        });
    }, []);

    const handleScrollPosition = () => {
      const scrollPosition = cardsState.scrollPosition;
  
      if (scrollPosition && navType === 'POP') {
        window.scrollTo({top: scrollPosition, behavior: 'auto'});
      }
      dispatch(saveScrollPosition(null))
    };
  
    useEffect(() => {
      isInitialFetched && handleScrollPosition();
    }, [isInitialFetched])
    
  

  if (!cardsState.items){
      return(
      <div>Загрузка</div>)
    }  

  return (
    <>
      {
        loading ? 
          <LoaderCircle/> 
            : 
          <div style={{ padding: '0px 15px'}} ref={sectionRef}>
            <Card>
                {cardsState.items?.filter((card) => !!card).sort((a,b) =>  b.createdAt.localeCompare(a.createdAt)).map((card, index) => (
                    <CardPreview
                      altWork={card.name} 
                      imageWork={card.imgUrl ?`https://toobears.com/api/${card.imgUrl[0]}` : defaultToy}
                      avatar={`https://toobears.com/api/${card.author.avatarUrl}` || defaultAvatar}
                      shopName={card.author.shopname || `${card.author.username} ${card.author.surname}`}
                      nameWork={card.name}
                      price={card.price + ' ' + card.currency}
                      size={card.size + 'cm'}
                      likeActive={card.like.includes(isAuth && isAuth._id)}    
                      status={card.status}  
                      link={`/card/${card._id}`}
                      key={card._id} 
                      discountEndedAt={card.discountEndedAt}
                      discount={card.discount}
                  />
                ))}
            </Card>
            <PaginationWrapper>
                {pagination.length > 1 &&
                  <>
                    <PaginationBtnFirst onClick={() => changePage(1)} >{`<<`}</PaginationBtnFirst>
                    {pagination.map((value) => 
                      value === cardsState.currentPage
                        ? <PaginationBtnActive key={value} disabled>{value}</PaginationBtnActive>
                        : value === DOTS
                          ? <PaginationBtn key={value}>{DOTS}</PaginationBtn>
                          : <PaginationBtn key={value} onClick={() => changePage(value)}>{value}</PaginationBtn>
                      )}
                    <PaginationBtnLast onClick={() => changePage(pagination[pagination.length - 1])} >{`>>`}</PaginationBtnLast>
                  </>
                }
            </PaginationWrapper>
          </div>
      }
    </>
  )
}

export default CardBlock